/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Plan_No_Management_UrlInputs */

const en_plan_no_management_url = /** @type {(inputs: Plan_No_Management_UrlInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.target} management URL is available for this account yet.`)
};

const es_plan_no_management_url = /** @type {(inputs: Plan_No_Management_UrlInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aún no hay una URL de administración de ${i?.target} disponible para esta cuenta.`)
};

/**
* | output |
* | --- |
* | "No {target} management URL is available for this account yet." |
*
* @param {Plan_No_Management_UrlInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_no_management_url = /** @type {((inputs: Plan_No_Management_UrlInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_No_Management_UrlInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_no_management_url(inputs)
	return en_plan_no_management_url(inputs)
});